<template>
  <div class="center">
    <!-- 返回按键 -->
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>

    <!-- 步骤条 -->
    <div class="stepcontent">
      <div
        class="stepitem"
        v-for="(item, index) in progressbartitle"
        :key="index"
        :class="{ steptwo: !(index <= isActive) }"
      >
        <span>{{ index + 1 }}{{ item }}</span>
        <!-- {{ "index:" + index + ",isActive:" + isActive }} -->
      </div>
    </div>

    <!-- 空行 -->
    <div class="konghuang"></div>

    <!-- 子页面 -->
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  props: ["changes"],
  components: {
    // 步骤页 -> 基本信息页面
    noticeBasis: () => import("./components/noticeBasis.vue"),
    // 步骤页 -> 考生管理页面
    noticeExaminee: () => import("./components/noticeExaminee.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "noticeBasis";
        case 1:
          return "noticeExaminee";
      }
      return "page";
    },
  },
  data() {
    return {
      isActive: 0,
      progressbartitle: [".公告基本信息", ".考生管理"],
    };
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.changes(0);
    },
    // 切换子页面
    cutcoms(index) {
      this.isActive = index;
    },
  },
  activated() {
    this.isActive = 0;
  },
};
</script>

<style lang='scss' scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

// 步骤内容css
.stepcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  // border-radius: 20% !important;
  background-color: #fff;
}

.stepitem {
  height: 45px;
  background-color: #1890ff;
  border-radius: 45px 45px 45px 45px;
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    // transform: translate(90px);
    z-index: 20;
    &::before {
      background-color: #1890ff;
    }
  }
  &:nth-child(2) {
    transform: translate(-45px);
    z-index: 10;
  }
  &::before {
    display: inline-block;
    position: absolute;
    content: "";
    width: 60px;
    height: 60px;
    background-color: rgb(255, 255, 255);
    border-radius: 50% 50%;
    transform: translate(-8px, -7px);
  }
  span {
    display: inline-block;
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    // font-weight: bold;
    color: #ffffff;
    padding-left: 71px;
    padding-right: 71px;
  }
}

.steptwo {
  background-color: #eeeeee;
  span {
    color: #bbbbbb !important;
  }
}

// 步骤和下面内容间的空行css
.konghuang {
  height: 24px;
  background-color: #f8f8f8;
}
</style>